module.exports = __webpack_public_path__ + "static/media/onama-2 2.cd2539b6.png";